import { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
const API_TOKEN = process.env.REACT_APP_AIRTABLE_API_TOKEN;

function CV() {
  const [numPages, setNumPages] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [updated, setUpdated] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pdfError, setPdfError] = useState(false);

  useEffect(() => {
    fetch(`https://api.airtable.com/v0/${BASE_ID}/Site%20Data`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const cvRecord = data.records?.find(
          (record) => record.fields.Name === 'CV'
        );

        if (cvRecord?.fields?.Attachments?.[0]) {
          setPdfUrl(cvRecord.fields.Attachments[0].url);
        }
        if (cvRecord?.fields?.Date) {
          setUpdated(cvRecord.fields.Date);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching CV:', err);
        setLoading(false);
      });
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error);
    setPdfError(true);
  };

  const isMobile = window.innerWidth < 768;
  const pdfWidth = isMobile ? window.innerWidth - 32 : window.innerWidth * 0.75;

  if (loading) {
    return (
      <section id="cv" className="pt-20 md:pt-32 pb-24 md:pb-16 px-4 md:px-0 flex flex-col items-center">
        <div className="text-gray-500">Loading...</div>
      </section>
    );
  }

  if (!pdfUrl) {
    return (
      <section id="cv" className="pt-20 md:pt-32 pb-24 md:pb-16 px-4 md:px-0 flex flex-col items-center">
        <div className="text-gray-500">CV not available</div>
      </section>
    );
  }

  return (
    <section id="cv" className="pt-20 md:pt-32 pb-24 md:pb-16 px-4 md:px-0 flex flex-col items-center">
      <div className="w-full md:w-3/4 flex justify-end gap-4 mb-2 text-sm text-gray-500">
        {updated && <span>Updated {updated}</span>}
        <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">
          Download
        </a>
      </div>
      {pdfError ? (
        <div className="w-full md:w-3/4 text-center py-16">
          <p className="text-gray-500 mb-4">Unable to display PDF in browser.</p>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 underline hover:text-gray-900"
          >
            Click here to view or download the CV
          </a>
        </div>
      ) : (
        <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} onLoadError={onDocumentLoadError}>
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={pdfWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      )}
    </section>
  );
}

export default CV;
